import api from "./client";

export async function login(username, password) {
  const { data } = await api.post("/api/auth/login", { username, password });
  return data; // { accessToken, refreshToken, user }
}

export async function getMe() {
  const { data } = await api.get("/api/auth/me");
  return data;
}
